"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCompatibleConsoleLogger = generateCompatibleConsoleLogger;
function generateCompatibleConsoleLogger() {
    const logger = {
        debug: (message, ...meta) => console.debug(message, ...meta),
        verbose: (message, ...meta) => console.log(message, ...meta),
        info: (message, ...meta) => console.log(message, ...meta),
        warn: (message, ...meta) => console.warn(message, ...meta),
        error: (message, ...meta) => console.error(message, ...meta),
    };
    return logger;
}
//# sourceMappingURL=ILogger.js.map